<template>
    <div>
        <b-alert
          :show="dismissCountDown"
          dismissible
          :variant="alertType"
          @dismissed="dismissCountDown=0"
        >{{ alertText }}</b-alert>

        <div class="form-group">
            <label>Current password </label>
            <input
            name="current_password"
            class="form-control"
            placeholder="********"
            type="password"
            v-model="$v.form.current_password.$model"
            />
        </div>

        <b-form-group
            id="new_password"
            label="New password"
            label-for="new_password">
            <b-form-input
                id="new_password"
                name="new_password"
                type="password"
                placeholder="********"
                v-model.lazy="$v.form.new_password.$model"
                :state="validateState('new_password')"
                aria-describedby="new_password-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback
                id="new_password-live-feedback"
            >Must be at least 7 characters and include a capital and number.</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
            id="confirm_password"
            label="Confirm password"
            label-for="confirm_password">
            <b-form-input
                id="confirm_password"
                name="confirm_password"
                type="password"
                placeholder="********"
                v-model="$v.form.confirm_password.$model"
                :state="validateState('confirm_password')"
                aria-describedby="confirm_password-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback
                id="confirm_password-live-feedback"
            >Please repeat the new password.</b-form-invalid-feedback>
        </b-form-group>

        <div class="form-group">
            <b-button
            type="submit"
            variant="primary"
            class="btn btn-primary btn-block"
            :disabled="disableSubmit"
            @click.prevent="updatePassword()">
            UPDATE PASSWORD
            </b-button>
        </div>
    </div>
</template>

<script>
import apiClient from '@/services/api_client_crm.js'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

function passwordComplexity (password) {
  // Minimum of 1 Uppercase Letter
  if (/[A-Z]/.test(password) === false) { return false }
  // Minimum of 1 Number
  if (/\d/.test(password) === false) { return false }
  // Minimum of 6 Characters
  // separately targeting input length to provide specific error message
  return true
};

export default {
  data () {
    return {
      alertType: 'warning',
      alertText: '',
      show_alert: false,
      dismissCountDown: 0,
      form: {
        current_password: '',
        new_password: '',
        confirm_password: ''
      }
    }
  },
  validations: {
    form: {
      current_password: { required, minLength: minLength(5) },
      new_password: { required, minLength: minLength(6), passwordComplexity },
      confirm_password: { minLength: minLength(6), sameAsPassword: sameAs('new_password') }
    }
  },
  methods: {
    validateState (name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    updatePassword () {
      // this.formTouched = this.$v.form.$anyDirty
      // this.errors = this.$v.form.$anyError
      // if (this.errors !== false || this.formTouched !== false) {
      //   // this is where you send the responses
      //   console.log("Form failed validation or hasn't been touched")
      //   return
      // }
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      apiClient.post('/api/password', {
        current_password: this.form.current_password,
        new_password: this.form.new_password
      }).then((response) => {
        // console.log(response.data)
        if ('error' in response.data) {
          this.alertType = 'danger'
          this.alertText = 'The current password is incorrect. Please retry.'
          this.dismissCountDown = 30
          this.form.current_password = ''
        } else {
          this.alertType = 'success'
          this.alertText = 'Password updated'
          this.dismissCountDown = 4
          this.form.new_password = ''
          this.form.current_password = ''
          this.form.confirm_password = ''
          this.$v.$reset()
        }
      })
    }
  },
  computed: {
    showAlert: {
      get () {
        return this.show_alert
      },
      set (value) {
        this.show_alert = value
      }
    },
    disableSubmit () {
      return this.$v.form.current_password.$invalid || this.$v.form.new_password.$invalid || this.$v.form.confirm_password.$invalid
    }
  }
}
</script>

<style scoped>

.form-control::-webkit-input-placeholder {
  color: #bbb;
}

</style>
